module.exports = "<rental-wizard-menu active-step=vmWizard.activeStepIndex steps=vmWizard.menuSteps></rental-wizard-menu> <form id=form> <div ng-transclude> </div></form>";


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard.html
// module id = 650
// module chunks = 0